import { ChangeDetectorRef, Component, EventEmitter, inject, Input, OnInit, Output, Type } from '@angular/core';
import { DynamicPageElement, DynamicPagesService } from '../../../services/dynamic-pages/dynamic-pages.service';
import { DynamicPageDcBaseComponent } from '../dynamic-page-dc-base/dynamic-page-dc-base.component';
import { DynamicPageEditorHelperService } from '../../../services/dynamic-page-editor-helper/dynamic-page-editor-helper.service';
import { GungNotificationService } from 'gung-common';

@Component({
  selector: 'lib-dynamic-page-dc-grid',
  standalone: false,
  templateUrl: './dynamic-page-dc-grid.component.html',
  styleUrl: './dynamic-page-dc-grid.component.scss'
})
export class DynamicPageDcGridComponent extends DynamicPageDcBaseComponent {
  dynamicPagesService = inject(DynamicPagesService);
  dynamicPageEditorHelperService = inject(DynamicPageEditorHelperService);
  protected gungNotificationService = inject(GungNotificationService);

  elementId = 'grid';

  fields = {
    cols: 3,
    gap: 24,
    marginTop: 0,
    marginRight: 0,
    marginBottom: 0,
    marginLeft: 0,
    paddingTop: 0,
    paddingRight: 0,
    paddingBottom: 0,
    paddingLeft: 0,
    mobileCols: 1,
    tabletCols: 2,
    colGrid0: [],
    colGrid1: [],
    colGrid2: []
  };

  ngOnInit(): void {
    if (!this.element) {
      this.element = { id: this.elementId, fields: {} };
    }
    if (Object.keys(this.element.fields).length === 0) {
      this.element.fields = this.fields;
    }
  }

  get currentSelected() {
    return this.dynamicPageEditorHelperService.getSelectedElement();
  }

  createComponentsCols() {
    const cols = this.element.fields.cols;

    // remove cols
    Object.keys(this.element.fields)
      .filter(key => key.startsWith('colGrid'))
      .forEach(key => {
        const index = +key.replace('colGrid', '');
        if (index >= cols) {
          delete this.element.fields[key];
        }
      });
    // create cols
    for (let i = 0; i < cols; i++) {
      if (!this.element.fields[`colGrid${i}`]) {
        this.element.fields[`colGrid${i}`] = [];
      }
    }
  }

  onDragOver(event: DragEvent) {
    event.preventDefault();
  }

  onDrop(event: DragEvent, index) {
    event.preventDefault();
    const draggedElement = this.dynamicPageEditorHelperService.draggedElement;
    if (draggedElement) {
      if (draggedElement.id === 'grid' || draggedElement.id === 'container') {
        this.gungNotificationService.notify('ERROR', 'Cannot add grid or container inside a grid', 'error');
        return;
      }
      let component: DynamicPageElement = {
        id: draggedElement.id,
        fields: {}
      };
      this.element.fields[`colGrid${index}`].push(component);
    }
  }

  onElementClick(comp: any, event: MouseEvent) {
    if (this.edit) {
      event.stopPropagation();
      this.dynamicPageEditorHelperService.setSelectedElement(this.element);
      this.dynamicPageEditorHelperService.editElementInGrid = comp;
    }
  }
  
  moveUp(colIndex: number, rowIndex: number) {
    const col = this.element.fields['colGrid' + colIndex];
    if (rowIndex > 0) {
      [col[rowIndex - 1], col[rowIndex]] = [col[rowIndex], col[rowIndex - 1]];
    }
  }

  moveDown(colIndex: number, rowIndex: number) {
    const col = this.element.fields['colGrid' + colIndex];
    if (rowIndex < col.length - 1) {
      [col[rowIndex + 1], col[rowIndex]] = [col[rowIndex], col[rowIndex + 1]];
    }
  }

  moveLeft(colIndex: number, rowIndex: number) {
    if (colIndex > 0) {
      const currentCol = this.element.fields['colGrid' + colIndex];
      const prevCol = this.element.fields['colGrid' + (colIndex - 1)];
      const [moved] = currentCol.splice(rowIndex, 1);
      prevCol.push(moved);
    }
  }

  moveRight(colIndex: number, rowIndex: number) {
    if (colIndex < this.element.fields.cols - 1) {
      const currentCol = this.element.fields['colGrid' + colIndex];
      const nextCol = this.element.fields['colGrid' + (colIndex + 1)];
      const [moved] = currentCol.splice(rowIndex, 1);
      nextCol.push(moved);
    }
  }

  deleteElement(colIndex: number, rowIndex: number) {
    const col = this.element.fields['colGrid' + colIndex];
    col.splice(rowIndex, 1);
  }

  copy(colIndex: number, rowIndex: number){
    this.dynamicPageEditorHelperService.copy = structuredClone(this.element.fields['colGrid' + colIndex][rowIndex]);
    console.log('this.dynamicPageEditorHelperService.copy ', this.dynamicPageEditorHelperService.copy );
  }

  paste(i){
    const copied = this.dynamicPageEditorHelperService.copy;
    if (copied?.id === 'grid' || copied?.id === 'container') {
      this.gungNotificationService.notify('ERROR', 'Cannot paste grid or container inside a grid', 'error');
      return;
    }
    this.element.fields[`colGrid${i}`] = [...this.element.fields[`colGrid${i}`], copied];
    this.dynamicPageEditorHelperService.copy = null;
  }
}
